export default __webpack_public_path__ + "static/media/MGP_2024_Fantasy_Launch_LDB_365x100.0c90cc9a.gif";